export const amostras = "/amostras";
export const lotes = "/lotes";
export const editarLote = "/lotes/{idLote}"
export const obterLote = "/lotes/{idLote}";
export const obterImagemBiopsiaLote = "/lotes/{idLote}/imagemBiopsia";
export const obterImagemAssinaturaLote = "/lotes/{idLote}/imagemAssinatura";
export const lotesAmostras = "/lotes/amostras";
export const lotesExcluirAmostra = "/lotes/{idLote}/amostras/{idAmostra}/codigoAmostra/{codigoAmostra}";
export const tipos = "/amostras/tipos";
export const status = "/amostras/status";
export const tiposLote = "/lotes/tipos";
export const statusLote = "/lotes/status";
export const empresas = "/empresas";
export const tiposConservacao = "/tipos-conservacao";
export const arquivosTemporarios = "/arquivos-temporarios";
export const listarAmostrasLote = "/lotes/{idLote}/amostras";
export const listarEventosLote = "/lotes/{idLote}/eventos";
export const exportarDadosLote = "/lotes/exportar/{idLote}"
export const gerarEtiquetaImpressaoLote = "/lotes/{idLote}/etiqueta";
export const possuiTipoConservacaoLote = "/lotes/{idLote}/tipoconservacao";
export const listarArquivos = "/amostras/{id}/arquivos";
export const baixarArquivos = "/amostras/{idAmostra}/arquivos/{idArquivoAmostra}";
export const planilhaLotes = "/lotes/gerarPlanilha";
export const planilhaAmostras = "/amostras/gerarPlanilha";
export const gerarManifestoCarga = "/lotes/gerarmanifestocargapdf";
export const listarConvenioPorLab = "/convenio/obterlistaconvenioporlaboratorio/{codigoLaboratorio}";
export const listarSolicitantes = "/solicitantes/nomeoucodigo";                                   
export const gerarReciboRecolhimento = "/lotes/gerarReciboDeRecolhimentoPdf";
export const exportarRelatorioUtilizacao = "/laboratorio/exportar/relatorioUtilizacao";
export const listarLaboratorios = "/laboratorio/listar";
export const gerarDadosEnvio = "/dadosenvio/gerarpdf"
